import { ContactModel } from '@boxx/contacts-core';
import { IEventsApiProps } from '../repositories/IEvents.repository';

export class EventModel implements IEventModelProps {
  id: number;
  title: string;
  description: string;
  place: string;
  datetimeFrom: string;
  datetimeTo: string;
  latitude?: string;
  longitude?: string;
  url?: string;
  attendees: ContactModel[];

  constructor(data: IEventModelProps) {
    this.id = data.id;
    this.title = data.title;
    this.url = data.url;
    this.description = data.description || '';
    this.place = data.place && data.place !== 'null' ? data.place : '';
    this.datetimeFrom = data.datetimeFrom;
    this.datetimeTo =
      data.datetimeTo && data.datetimeTo !== '0000-00-00 00:00:00'
        ? data.datetimeTo
        : null;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.attendees = data.attendees;
  }

  static fromDataResponse(data: IEventsApiProps): EventModel {
    data.attendees = data.attendees || [];

    return new EventModel({
      id: +data.id,
      title: data.title,
      description: data.description,
      place: data.place,
      datetimeFrom: data.datetime_from,
      datetimeTo: data.datetime_to,
      latitude: data.latitude,
      longitude: data.longitude,
      url: data.url,
      attendees: data.attendees.map((c) =>
        ContactModel.fromDataResponse({
          id: c.contact_id,
          email: c.email,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          full_name: c.full_name,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          last_name: c.last_name,
          name: c.name,
          phone: c.phone,
        })
      ),
    });
  }

  static empty(): EventModel {
    return new EventModel({
      id: null,
      title: null,
      description: null,
      place: null,
      datetimeFrom: null,
      datetimeTo: null,
      url: null
    });
  }

  static clone(event: EventModel) {
    return new EventModel({
      id: event.id,
      title: event.title,
      description: event.description,
      place: event.place,
      datetimeFrom: event.datetimeFrom,
      datetimeTo: event.datetimeTo,
      latitude: event.latitude,
      longitude: event.longitude,
      attendees: [...event.attendees],
      url: event.url
    });
  }
}

export interface IEventModelProps {
  id: number;
  title: string;
  description: string;
  place: string;
  datetimeFrom: string;
  datetimeTo: string;
  latitude?: string;
  longitude?: string;
  url?: string;
  attendees?: ContactModel[];
}

export interface ITask {
  id: number;
  title: string;
  reminder_sub_minutes: number;
  type: string;
  priority: number;
  datetime: string;
  datetimeFromFormat: string;
  notes: string;
  contact_id: number
  send_reminder:  number
}